<template>
  <carousel
    :perPage="1"
    :paginationActiveColor="'#FFA500'"
    :paginationPadding="5"
    :autoplay="true"
    :loop="true"
    :autoplayTimeout="6000"
    :autoplayHoverPause="true"
  >
    <slide v-for="(news, index) in data" :key="index">
      <div class="row mx-0">
        <div class="col-12 item-background" :style="{backgroundImage: `url(/${$staticPath}/${news.src})`}" @click="goNewsById(news.newsId)">
          <div class="item-text-area">
            <h4 class="item-text-header">{{news.header}}</h4>
            <div class="item-text-time">
              <i class="fa fa-clock-o" aria-hidden="true"></i> : {{news.time}}
            </div>
          </div>
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  components: {
    carousel: Carousel,
    slide: Slide
  },
  props: ['data'],
  methods: {
    goNewsById (newsId) {
      this.$emit('goNewsById', newsId)
    }
  }
}
</script>

<style scoped>
.item-background {
  position: relative;
  padding-top: 56.25%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}

.item-text-area {
  background-color: rgba(35, 35, 35, 0.8);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  padding: 15px;
  width: 200px;
}

.item-text-area .item-text-header {
  color: #FFA500;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  line-height: 1.3;
}

.item-background:hover .item-text-header{
  text-decoration: underline;
}

.item-text-area .item-text-time {
  position: absolute;
  bottom: 15px;
  right: 15px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/HOME/CarouselNews.vue